import React from 'react';

export const SvgFirstPage = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.999 7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V7zm5.82 5l3.88 3.89c.39.38.39 1.02.01 1.4a.996.996 0 01-1.41 0l-4.59-4.59a.996.996 0 010-1.41l4.59-4.59a.996.996 0 111.41 1.41L13.819 12z"
      fill="currentColor"
    />
  </svg>
);
